import { countCodePoints } from "@common-ui/utilities/characterCount";
import type { LocationQuery } from "vue-router";

export const MAX_SEARCH_LENGTH = 250;
export const SEARCH_LENGTH_MESSAGE = `Search must be ${MAX_SEARCH_LENGTH} characters or fewer.`;

export function isSearchTooLong(value: string | null | undefined): boolean {
	return countCodePoints(value ?? "") > MAX_SEARCH_LENGTH;
}

/** Show the counter only with overflow validation, keeping normal searches uncluttered. */
export function searchFieldProps(value: string | null | undefined, existingErrors: string | readonly string[] = []) {
	const tooLong = isSearchTooLong(value);
	const errors = typeof existingErrors === "string" ? [existingErrors] : existingErrors;
	return {
		counter: tooLong ? MAX_SEARCH_LENGTH : false,
		counterValue: () => countCodePoints(value ?? ""),
		persistentCounter: tooLong,
		hideDetails: "auto" as const,
		errorMessages: [...(tooLong ? [SEARCH_LENGTH_MESSAGE] : []), ...errors.filter(Boolean)],
		"aria-invalid": tooLong ? "true" : undefined
	};
}

/** Drop oversized deep-link terms before page setup, auth redirects, or API calls. */
export function withoutOversizedSearch(query: LocationQuery): LocationQuery | null {
	const next = { ...query };
	let changed = false;
	for (const key of ["searchTerm", "search", "q", "report_search"]) {
		const value = query[key];
		if ((Array.isArray(value) ? value : [value]).some((term) => isSearchTooLong(term))) {
			delete next[key];
			changed = true;
		}
	}
	return changed ? next : null;
}
